import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import Header from './components/Header';
import YearConverter from './components/YearConverter/YearConverter';
import EraTable from './components/EraTable/EraTable';
import AnnualBudget from './components/AnnualBudget/AnnualBudget';
import commonStyles from './styles/common.module.css';

// Reactアプリケーションコンポーネント
const App = () => {
  const [yearSelection, setYearSelection] = useState(null);
  
  // アプリケーション判定
  const isYearConverter = document.getElementById('year-converter-app');
  const reactAppElement = document.getElementById('react-app');
  const isAnnualBudget = reactAppElement?.classList.contains('annual-budget-app');
  
  // 年選択ハンドラ
  const handleYearSelect = (yearData) => {
    setYearSelection(yearData);
  };
  
  // 表示するアプリケーションを決定
  if (isAnnualBudget) {
    return <AnnualBudget />;
  }
  
  // デフォルト：年号計算アプリ
  return (
    <div className={commonStyles.container}>
      <Header />
      <div className={commonStyles.pageContainer}>
        <YearConverter 
          yearSelection={yearSelection} 
        />
        <EraTable onYearSelect={handleYearSelect} />
      </div>
    </div>
  );
};

// Reactアプリケーションの初期化
const initializeReactApp = () => {
  console.log('Initializing React application');

  // メインのReactアプリケーションコンテナ
  const appContainer = document.getElementById('react-app') || document.getElementById('year-converter-app');
  if (appContainer) {
    console.log('Mounting React application');
    const root = createRoot(appContainer);
    root.render(<App />);
  } else {
    console.warn('React app container not found');
  }
};

// Turbo:loadイベントで初期化
document.addEventListener('turbo:load', () => {
  console.log('Turbo:load in React app');
  initializeReactApp();
});

// フォールバック：DOMContentLoadedイベントで初期化
document.addEventListener('DOMContentLoaded', () => {
  console.log('DOMContentLoaded in React app');
  if (!window.turboLoadFired) {
    console.log('Turbo:load not fired, initializing from DOMContentLoaded');
    initializeReactApp();
  }
}); 